/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_State_PauseInputs */

const en_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Temporarily Paused`)
};

const ar_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحدث متوقف مؤقتًا`)
};

const de_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis vorübergehend pausiert`)
};

const es_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento pausado temporalmente`)
};

const fr_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement temporairement suspendu`)
};

const it_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento temporaneamente sospeso`)
};

const ja_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント一時停止中`)
};

const ko_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 일시 중지됨`)
};

const pt_br_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento pausado temporariamente`)
};

const ru_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие временно приостановлено`)
};

const th_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระงับกิจกรรมชั่วคราว`)
};

const tr_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik geçici olarak durduruldu`)
};

const zh_cn_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动暂停`)
};

const zh_tw_event_state_pause = /** @type {(inputs: Event_State_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動暫停`)
};

/**
* | output |
* | --- |
* | "Event Temporarily Paused" |
*
* @param {Event_State_PauseInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_pause = /** @type {((inputs?: Event_State_PauseInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_PauseInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_pause(inputs)
	if (locale === "ar") return ar_event_state_pause(inputs)
	if (locale === "de") return de_event_state_pause(inputs)
	if (locale === "es") return es_event_state_pause(inputs)
	if (locale === "fr") return fr_event_state_pause(inputs)
	if (locale === "it") return it_event_state_pause(inputs)
	if (locale === "ja") return ja_event_state_pause(inputs)
	if (locale === "ko") return ko_event_state_pause(inputs)
	if (locale === "pt_br") return pt_br_event_state_pause(inputs)
	if (locale === "ru") return ru_event_state_pause(inputs)
	if (locale === "th") return th_event_state_pause(inputs)
	if (locale === "tr") return tr_event_state_pause(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_pause(inputs)
	return zh_tw_event_state_pause(inputs)
});